import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Field, FieldBody, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { Prefix, Input } from 'web-ui-components/lib/atoms/forms';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { getTransactionBalRequestPacket } from '../../utils/RequestPacketBuilder';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';
import { getTransactionAmountContent } from '../../businessLogic/AlertsBL';

export class TransactionAmount extends Component {
  constructor(props) {
    super(props);
    this.handleAlertCheck = this.handleAlertCheck.bind(this);
    this.confirmAlertChange = this.confirmAlertChange.bind(this);
    this.toggleOptionFactory = this.toggleOptionFactory.bind(this);
  }

  handleAlertCheck() {
    const {
      isTransactionAmountEnable,
      defaultAmount,
      handleTransactionBalRequestPacket,
      showButton,
      incomingTransactionValidation,
    } = this.props;
    const transactionBalRequestPacket = getTransactionBalRequestPacket(
      !isTransactionAmountEnable,
      defaultAmount,
      incomingTransactionValidation
    );
    handleTransactionBalRequestPacket(transactionBalRequestPacket, 'toggle');
    showButton(false);
  }

  confirmAlertChange() {
    const {
      handleTransactionBalRequestPacket,
      showButton,
      isLoading,
      transactionAmount,
      incomingTransactionValidation,
    } = this.props;
    const transactionBalRequestPacket = getTransactionBalRequestPacket(
      true,
      transactionAmount,
      incomingTransactionValidation
    );
    handleTransactionBalRequestPacket(transactionBalRequestPacket);
    showButton(isLoading);
  }

  toggleOptionFactory() {
    const { content, isTransactionAmountEnable, incomingTransactionValidation } = this.props;
    const { transactionAmountEnableText: enableText, trasactionAmountDisableText: disableText } =
      getTransactionAmountContent(incomingTransactionValidation, content);
    const setAmountToggleText = isTransactionAmountEnable ? enableText : disableText;
    const displayIcon = (
      <Icon iconType="GenericMoneyOutlineLarge" className="c-a-button__icon" direction="right" />
    );
    return (
      <ToggleOption
        icon={displayIcon}
        title={content.transactionAmountTitle}
        blurb={setAmountToggleText}
        active={isTransactionAmountEnable}
        onChange={this.handleAlertCheck}
      />
    );
  }

  render() {
    const { poundSign, cancelText, confirmText, alertValidationMsg, transactionSME } =
      this.props.content;
    const {
      isTransactionAmountEnable,
      incomingTransactionValidation,
      isAmountValid,
      showAmountButton,
      cancelAlertChanges,
      isLoading,
      transactionAmount,
      handleAmountChange,
      handleOnBlur,
    } = this.props;
    const validationMessage = incomingTransactionValidation ? transactionSME : alertValidationMsg;
    return (
      <Card bordered="unbranded" className="u-component-spacing">
        <TogglePanel
          toggleOptionFactory={this.toggleOptionFactory}
          active={isTransactionAmountEnable}
          onChange={this.handleAlertCheck}
        >
          {isTransactionAmountEnable && (
            <div className="u-padding-top-2">
              <Field>
                <FieldBody>
                  <Prefix>{poundSign}</Prefix>
                  <Input
                    type="text"
                    value={transactionAmount}
                    onChange={handleAmountChange}
                    onBlur={handleOnBlur}
                    hasPrefix
                  />
                </FieldBody>
              </Field>
              {isAmountValid && (
                <ValidationMessage value={validationMessage} iconType="ExclamationCircleLarge" />
              )}
            </div>
          )}
          {showAmountButton && !isAmountValid && (
            <ButtonGroup>
              <Button className="u-margin-right-2" display="secondary" onClick={cancelAlertChanges}>
                {cancelText}
              </Button>
              <Button display="primary" onClick={this.confirmAlertChange} isLoading={isLoading}>
                {confirmText}
              </Button>
            </ButtonGroup>
          )}
        </TogglePanel>
      </Card>
    );
  }
}
TransactionAmount.propTypes = {
  content: PropTypes.shape({
    poundSign: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    alertValidationMsg: PropTypes.string,
    transactionSME: PropTypes.string,
  }),
  isTransactionAmountEnable: PropTypes.bool,
  transactionAmount: PropTypes.string,
  handleTransactionBalRequestPacket: PropTypes.func,
  handleAmountChange: PropTypes.func,
  showButton: PropTypes.func,
  cancelAlertChanges: PropTypes.func,
  showAmountButton: PropTypes.bool,
  defaultAmount: PropTypes.number,
  isLoading: PropTypes.bool,
  handleOnBlur: PropTypes.func,
  isAmountValid: PropTypes.bool,
  incomingTransactionValidation: PropTypes.func,
};

export default TransactionAmount;
